import React from 'react'

import { ReactComponent as HeartSVG } from '../../lib/assets/suits/heart.svg'
import { ReactComponent as SpadeSVG } from '../../lib/assets/suits/spades.svg'
import { ReactComponent as ClubSVG } from '../../lib/assets/suits/club.svg'
import { ReactComponent as DiamondSVG } from '../../lib/assets/suits/diamond.svg'
import { colors } from '../../lib/colors'

export const royalFlush = [
  {
    name: '10',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: 'J',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: 'Q',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: 'K',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: 'A',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
]

export const straightFlush = [
  {
    name: '7',
    suit: <ClubSVG />,
    color: colors.secondaryBackground,
    win: true,
  },
  {
    name: '8',
    suit: <ClubSVG />,
    color: colors.secondaryBackground,
    win: true,
  },
  {
    name: '9',
    suit: <ClubSVG />,
    color: colors.secondaryBackground,
    win: true,
  },
  {
    name: '10',
    suit: <ClubSVG />,
    color: colors.secondaryBackground,
    win: true,
  },
  {
    name: 'J',
    suit: <ClubSVG />,
    color: colors.secondaryBackground,
    win: true,
  },
]

export const fourOfAKind = [
  {
    name: 'Q',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: 'Q',
    suit: <DiamondSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: 'Q',
    suit: <ClubSVG />,
    color: colors.secondaryBackground,
    win: true,
  },
  {
    name: 'Q',
    suit: <SpadeSVG />,
    color: colors.secondaryBackground,
    win: true,
  },
  {
    name: '6',
    suit: <DiamondSVG />,
    color: colors.secondaryText,
    win: false,
  },
]

export const fullHouse = [
  {
    name: 'Q',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: 'Q',
    suit: <DiamondSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: '2',
    suit: <ClubSVG />,
    color: colors.secondaryBackground,
    win: true,
  },
  {
    name: '2',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: '2',
    suit: <SpadeSVG />,
    color: colors.secondaryBackground,
    win: true,
  },
]

export const flush = [
  {
    name: '2',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: '4',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: '7',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: '10',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: 'A',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
]

export const straight = [
  {
    name: '2',
    suit: <DiamondSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: '3',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: '4',
    suit: <ClubSVG />,
    color: colors.secondaryBackground,
    win: true,
  },
  {
    name: '5',
    suit: <SpadeSVG />,
    color: colors.secondaryBackground,
    win: true,
  },
  {
    name: '6',
    suit: <DiamondSVG />,
    color: colors.secondaryText,
    win: true,
  },
]

export const threeOfAKind = [
  {
    name: 'K',
    suit: <DiamondSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: 'K',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: 'K',
    suit: <ClubSVG />,
    color: colors.secondaryBackground,
    win: true,
  },
  {
    name: '5',
    suit: <SpadeSVG />,
    color: colors.secondaryBackground,
    win: false,
  },
  {
    name: '9',
    suit: <DiamondSVG />,
    color: colors.secondaryText,
    win: false,
  },
]

export const twoPairs = [
  {
    name: 'Q',
    suit: <DiamondSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: 'Q',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: '4',
    suit: <ClubSVG />,
    color: colors.secondaryBackground,
    win: false,
  },
  {
    name: '2',
    suit: <SpadeSVG />,
    color: colors.secondaryBackground,
    win: true,
  },
  {
    name: '2',
    suit: <DiamondSVG />,
    color: colors.secondaryText,
    win: true,
  },
]

export const onePair = [
  {
    name: 'A',
    suit: <DiamondSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: 'A',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: '4',
    suit: <ClubSVG />,
    color: colors.secondaryBackground,
    win: false,
  },
  {
    name: '1',
    suit: <SpadeSVG />,
    color: colors.secondaryBackground,
    win: false,
  },
  {
    name: 'Q',
    suit: <DiamondSVG />,
    color: colors.secondaryText,
    win: false,
  },
]

export const highCard = [
  {
    name: 'A',
    suit: <DiamondSVG />,
    color: colors.secondaryText,
    win: true,
  },
  {
    name: '5',
    suit: <HeartSVG />,
    color: colors.secondaryText,
    win: false,
  },
  {
    name: '4',
    suit: <ClubSVG />,
    color: colors.secondaryBackground,
    win: false,
  },
  {
    name: '1',
    suit: <SpadeSVG />,
    color: colors.secondaryBackground,
    win: false,
  },
  {
    name: 'Q',
    suit: <DiamondSVG />,
    color: colors.secondaryText,
    win: false,
  },
]
